const config = {
    target: '.c-parts-list__table, .c-parts-list-basket__container',
    button: '.js-parts-button'
};

$(document).ready(function(){
    const $target = $(config.target);
    const $buttons = $(config.button);

    if (!$target.hasClass('open--force')) {
        $target.removeClass('open');
    }

    $buttons.click(function() {
        const $this = $(this);
        const $table = $(this).prevAll(config.target);
        const isOpen = $table.hasClass("open");

        $table.toggleClass("open", !isOpen);
        $this.siblings(config.button).toggleClass("hidden");
        $this.toggleClass("hidden");
    });
});



// WEBPACK FOOTER //
// ./src/js/components/table-expand.js